<div class="desktop" #desktop>
  @for (app of desktopApps; track app.id) {
    <button
      class="desktop-icon"
      [class.selected]="selectedIcon === app.id"
      (click)="onIconClick($event, app)"
      (dblclick)="openApp(app)"
    >
      <img class="icon-image" [alt]="app.title + ' Icon'" [src]="app.iconSrc"/>
      <div class="icon-text">{{ app.title }}</div>
    </button>
  }

  @for (w of genericWindows; track w.id) {
    @if (w.visible && !w.minimized) {
      <div
        class="window"
        [ngClass]="animClassFor(w)"
        [attr.data-win-id]="w.id"
        [style.left.px]="w.position.x"
        [style.top.px]="w.position.y"
        [style.width.px]="w.size.width"
        [style.height.px]="w.size.height"
        [style.z-index]="w.zIndex"
        (mousedown)="bringGenericToFront(w.id)"
      >
        <div class="window-header" (mousedown)="startGenericDrag($event, w.id)">
          <div class="window-title">{{ w.title }}</div>
          <div class="window-controls">
            <button class="control-button" (click)="minimizeGenericWindow(w.id)">_</button>
            <button class="control-button" (click)="closeGenericWindow(w.id)">×</button>
          </div>
        </div>
        <div class="window-content">
          <ng-container *ngComponentOutlet="w.component; injector: w.injector"></ng-container>
        </div>
        <div class="resize-handle" (mousedown)="startGenericResize($event, w.id)"></div>
      </div>
    }
  }
</div>

<div class="taskbar">
  <button class="start-button" (click)="toggleStartMenu()">Start</button>

  @if (startMenuVisible) {
    <div class="start-menu">
      <button class="start-menu-item" (click)="disconnectWallet()">Logout</button>
    </div>
  }

  @for (w of genericWindows; track w.id) {
    <button class="taskbar-item" [class.active]="!w.minimized" (click)="restoreGenericWindow(w.id)">
      {{ w.title }}
    </button>
  }

  <div class="clock">{{ currentTime }}</div>
</div>
